/*
  Produktsidans galleri visar bara den valda färgens bilder: framsida, baksida och sidor.
  Färgen läses ur bildernas alt-text ("Produkt – Färg" eller "Produkt – Färg – vy", samma text som
  designern använder). Bilder utan färg i alt-texten (storleksguide, miljöbilder) syns alltid.
  Färgerna och vilken färg varje variant har kommer från <script data-mn-galleri> i main-product.
  Körs vid sidladdning och efter varje variantbyte (Dawns PUB_SUB_EVENTS.variantChange).
*/
(() => {
  function info(rot) {
    const el = rot.querySelector('script[data-mn-galleri]');
    if (!el) return null;
    try {
      const d = JSON.parse(el.textContent);
      return { farger: new Set(d.farger), varianter: d.varianter };
    } catch (e) {
      return null;
    }
  }

  function bildensFarg(el, farger) {
    const img = el.matches('img') ? el : el.querySelector('img');
    const alt = img ? img.getAttribute('alt') || '' : '';
    const delar = alt.split(' – ');
    return delar.length >= 2 && farger.has(delar[1].trim()) ? delar[1].trim() : null;
  }

  function valdFarg(rot, d) {
    const id = rot.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    return (id && d.varianter[id]) || null;
  }

  function filtrera(rot) {
    const d = info(rot);
    if (!d || !d.farger.size) return;
    const farg = valdFarg(rot, d);
    if (!farg) return;
    const galleri = rot.querySelector('media-gallery');
    const delar = [
      ...rot.querySelectorAll('media-gallery li[data-media-id], media-gallery li[data-target]'),
      ...document.querySelectorAll('product-modal .product-media-modal__content > [data-media-id]'),
    ];
    for (const el of delar) {
      const f = bildensFarg(el, d.farger);
      el.classList.toggle('mn-annan-farg', !!f && f !== farg);
    }
    // den aktiva bilden får inte vara en dold färg
    const aktiv = galleri?.querySelector('li[data-media-id].is-active');
    if (galleri && aktiv && aktiv.classList.contains('mn-annan-farg')) {
      const forsta = galleri.querySelector('li[data-media-id]:not(.mn-annan-farg)');
      if (forsta && galleri.setActiveMedia) galleri.setActiveMedia(forsta.dataset.mediaId, false);
    }
    rot.querySelectorAll('slider-component').forEach((s) => s.resetPages?.());
  }

  function alla() {
    document.querySelectorAll('product-info, [id^="MainProduct-"]').forEach((rot) => {
      if (rot.querySelector('script[data-mn-galleri]')) filtrera(rot);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alla);
  else alla();

  // efter variantbyte: Dawn har då lagt in den nya färgens framsida i galleriet
  const koppla = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(alla));
      return true;
    }
    return false;
  };
  if (!koppla()) window.addEventListener('load', () => koppla() || document.addEventListener('change', (e) => {
    if (e.target.closest('variant-selects, variant-radios')) setTimeout(alla, 600);
  }));
})();
